import { PopupAuthenticator, isMsalPopupAuthenticator } from '@ms/yammer-web-authenticators';
import { CookieOptions, isThirdPartyCookieError, remove, set } from '@ms/yammer-web-support/dist/cookies';
import { isSameSiteNoneCompatible } from 'should-send-same-site-none';

import { setLocaleFromUserData } from '../1-main/bootstrapActions';
import { loadThirdPartyCookieRenderer } from '../3-render';

export const testCookieName = 'cookietest';
export const testCookieValue = '1';
export const sameSiteNone: CookieOptions = { sameSite: 'none' };

type IsThirdPartyCookieDisabled = () => boolean;
export const isThirdPartyCookieDisabled: IsThirdPartyCookieDisabled = () => {
  const cookieOptions = isSameSiteNoneCompatible(navigator.userAgent) ? sameSiteNone : undefined;

  try {
    set(testCookieName, testCookieValue, cookieOptions);
    remove(testCookieName, cookieOptions);

    return false;
  } catch (error) {
    return isThirdPartyCookieError(error);
  }
};

export const shouldRenderThirdPartyCookieDisabled = (authenticator: PopupAuthenticator) => {
  const isMsal = isMsalPopupAuthenticator(authenticator);

  return !isMsal && isThirdPartyCookieDisabled();
};

export const renderThirdPartyCookieDisabled = async () => {
  const createStore = await import(/* webpackChunkName: "4-feat-create-store" */ '../1-main/createStore');
  const { store } = createStore.createYammerEmbedStore();
  const { dispatch, getState } = store;
  setLocaleFromUserData(dispatch, getState());

  const render = await loadThirdPartyCookieRenderer();
  const renderRoot = document.getElementById('root') as HTMLElement;

  render({ store, target: renderRoot });
};
